import React from "react";
import "../../../css/BoletinOficial/defensor-vecino.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

// Años para informes y detalles
const ANIOS_INFORMES = [2024, 2023, 2022, 2021];
const ANIOS_DETALLES = [2024, 2023, 2022];

// Función para la URL de informes
const urlInforme = (anio) =>
  `https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/informe/Informe-Defensor-del-Vecino-${anio}.pdf`;

// Función para la URL de detalles
const urlDetalle = (anio) =>
  `https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/detalle/Detalle-de-expedientes-y-consultas-${anio}.pdf`;

// Informes especiales
const informesEspeciales = [
  {
    label: "Informe especial (art. 18 Ord. 123/2020)",
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/Defensor-del-Vecino-Informe-especial-art-18-Ord-123.2020.pdf",
  },
];

const DefensorVecino = () => (
  <div className="defensor-full-bg">
    <div className="defensor-container">
      <h1 className="defensor-title">DEFENSOR DEL VECINO</h1>
      <p className="defensor-desc">
        Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía.
      </p>
      <div className="defensor-btn-list-grid">
        {/* Fila 2021: Informe + Informe especial (ahora es la última fila) */}
        {ANIOS_INFORMES.filter((anio) => anio !== 2021).map((anio) => (
          <React.Fragment key={anio}>
            <a
              href={urlInforme(anio)}
              target="_blank"
              rel="noopener noreferrer"
              className="defensor-btn"
            >
              <FontAwesomeIcon icon={faPaperclip} className="defensor-btn-icon" />
              {`INFORME ${anio}`}
            </a>
            {ANIOS_DETALLES.includes(anio) ? (
              <a
                href={urlDetalle(anio)}
                target="_blank"
                rel="noopener noreferrer"
                className="defensor-btn"
              >
                <FontAwesomeIcon icon={faPaperclip} className="defensor-btn-icon" />
                {`DETALLE DE EXPEDIENTES Y CONSULTAS ${anio}`}
              </a>
            ) : (
              <span className="defensor-btn defensor-btn-empty"></span>
            )}
          </React.Fragment>
        ))}
        {/* Última fila: Informe 2021 + Informe especial */}
        <a
          href={urlInforme(2021)}
          target="_blank"
          rel="noopener noreferrer"
          className="defensor-btn"
        >
          <FontAwesomeIcon icon={faPaperclip} className="defensor-btn-icon" />
          INFORME 2021
        </a>
        <a
          href={informesEspeciales[0].url}
          target="_blank"
          rel="noopener noreferrer"
          className="defensor-btn"
        >
          <FontAwesomeIcon icon={faPaperclip} className="defensor-btn-icon" />
          {informesEspeciales[0].label}
        </a>
      </div>
    </div>
  </div>
);

export default DefensorVecino;